<organ-navbar-mb></organ-navbar-mb>
<ng-container *ngIf="!(isLogin$ | async)">
  <dialog-frictionless-login></dialog-frictionless-login>
</ng-container>

<div class="px-10">
  <router-outlet></router-outlet>
</div>

<!-- <lazy-load (displayEvent)="ui.show.footer = true">
  <template-footer [isLogin]="(isLogin$ | async)"></template-footer>
</lazy-load> -->